import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useCompBackgroundColor, useCompContext } from '@/context/__project__/CompContext'
import { useDbClientContext } from '@/context/__project__/DbClientContext'
import { useAppBuilderContext } from '@/context/AppBuilderContext'

import { CompArrayGalleryWrapperCore } from '../core/array-gallery/wrapper'

/**
 * CompArrayGalleryWrapper
 */
function CompArrayGalleryWrapper() {
  // infos
  const compContext = useCompContext()
  const { currentParentBg } = useCompBackgroundColor()
  const { activeLayer } = useActiveLayerContext()
  const infosProps = { ...compContext, activeLayer, currentParentBg }

  // access table
  const { dbClient, tablesMap } = useDbClientContext()
  const tableId = compContext.detailTableId
  const dbTable = tableId ? tablesMap.get(tableId) : undefined

  // extra
  const { setGalleryModal } = useAppBuilderContext()

  if (!dbClient || !dbTable || !tableId) return null

  return (
    <CompArrayGalleryWrapperCore
      infos={infosProps}
      tableData={{ dbClient, dbTable, tableId }}
      setGalleryModal={setGalleryModal}
    />
  )
}

export default CompArrayGalleryWrapper
